import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import CookieBanner from "./components/CookieBanner";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes />
        <CookieBanner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
